export default __webpack_public_path__ + "static/media/taskArchive.be6cc431.svg";